'use client';

import { usePathname } from 'next/navigation';
import { TMenuBreadcrumbs, TMenuConfig } from '../types';

// Simple matcher to handle static and dynamic routes (e.g. /products/[id] or /products/:id)
const matchPath = (pathname: any, configPath: string): boolean => {
  const pathParts: any = pathname?.split('/').filter(Boolean);
  const configParts = configPath.split('/').filter(Boolean);

  if (pathParts.length !== configParts.length) return false;

  return configParts.every((part, idx) => {
    return part.startsWith('[') || part.startsWith(':') || part === pathParts[idx];
  });
};

const useMenuBreadcrumbs = (items: TMenuConfig | null): TMenuBreadcrumbs => {
  const pathname = usePathname();

  const findParents = (items: TMenuConfig | null): TMenuBreadcrumbs => {
    if (!items) return [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.path && matchPath(pathname, item.path)) {
        return [
          {
            title: item.title,
            path: item.path,
            active: true,
          }
        ];
      } else if (item.children) {
        const parents = findParents(item.children as TMenuConfig);

        if (parents.length > 0) {
          return [item, ...parents];
        }
      }
    }

    return [];
  };

  return findParents(items);
};

export { useMenuBreadcrumbs };
